/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface V3CustomersMeNotificationsNotificationIdDelete$Xml$Params {
  notificationId: string;
}

export function v3CustomersMeNotificationsNotificationIdDelete$Xml(http: HttpClient, rootUrl: string, params: V3CustomersMeNotificationsNotificationIdDelete$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, v3CustomersMeNotificationsNotificationIdDelete$Xml.PATH, 'delete');
  if (params) {
    rb.path('notificationId', params.notificationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

v3CustomersMeNotificationsNotificationIdDelete$Xml.PATH = '/v3/customers/me/notifications/{notificationId}';
